import React from "react";
import { Flex, Button, Text } from "@mantine/core";

const AiActionButtons = ({ handleAiAssistantSubmit, buttonData = [] }) => {
  return (
    <Flex justify="flex-end" align="center" mt="xs" gap="sm">
      {buttonData?.map((btn, index) => (
        <Button
          key={index}
          radius="md"
          onClick={() => handleAiAssistantSubmit(btn?.prompt)}
          styles={{
            root: {
              backgroundColor: "rgba(120, 86, 255, 0.25)",
              color: "#000",
              "&:hover": {
                backgroundColor: "rgba(120, 86, 255, 0.50)",
              },
            },
            section: {
              marginRight: 6,
            },
          }}
        >
          <Flex gap={10} align="center">
            {btn?.icon &&
              (typeof btn?.icon === "string" ? (
                <img
                  style={{ width: "25px", height: "25px", borderRadius: "5px" }}
                  src={btn?.icon}
                  alt={btn?.label}
                />
              ) : (
                btn?.icon
              ))}
            <Text ff="Inter" fw={400}>
              {btn?.label}
            </Text>
          </Flex>
        </Button>
      ))}
    </Flex>
  );
};

export default AiActionButtons;
